import React from 'react';
import { Box, Typography } from '@mui/material';
import { ReportProblem } from '@mui/icons-material';
import { Link } from 'react-router-dom';

import { Button } from './core/Button/Button';

export const UnauthorizedMerchant: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'background.light',
        width: '100%',
        px: 4,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: 600,
          textAlign: 'center',
          pb: 16,
        }}
      >
        <ReportProblem sx={{ fontSize: 64, mb: 3, color: 'warning.main' }} />
        <Typography component="h1" variant="h4" fontWeight="semibold" sx={{ mb: 2 }}>
          Access Denied
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          This merchant account might not exist or you do not have access to it. If you believe this
          is an error, please contact support@skipify.com for assistance.
        </Typography>
        <Button
          component={Link}
          to="/"
          variant="contained"
          color="primary"
          text="Return to my merchants"
          sx={{ px: 4 }}
        />
      </Box>
    </Box>
  );
};
